    <template>
        <div class="ele-body">
            <el-card shadow="never">
                <!-- 搜索表单 -->
                <el-form v-if="search_show" :model="table.where" label-width="auto" :inline="true"
                    @keyup.enter.native="$refs.table.reload()" @submit.native.prevent>
                    <el-row :gutter="15">


                        <el-form-item label="分类名称:">
                            <el-select v-model="table.where.cate_id" filterable placeholder="请选择">
                                <el-option v-for="item in activity_turntable_prize_cate_list" :key="item.id"
                                    :label="item.title" :value="item.id">
                                </el-option>
                            </el-select>
                        </el-form-item>

                        <el-form-item label="奖项名称:">
                            <el-input v-model="table.where.prize_name" placeholder="请输入奖项名称" clearable />
                        </el-form-item>


                        <el-form-item label="奖品排序:">
                            <el-input-number v-model="table.where.sort" placeholder="请输入奖品排序" :controls="false"
                                controls-position="right" class="ele-fluid ele-text-left" clearable />
                        </el-form-item>

                        <el-form-item label="创建时间:">
                            <el-date-picker v-model="table.where.create_time" type="datetimerange"
                                start-placeholder="开始日期" end-placeholder="结束日期" value-format="yyyy-MM-dd hh:mm:ss">
                            </el-date-picker>
                        </el-form-item>
                        <el-form-item>
                            <el-button type="primary" @click="$refs.table.reload()" icon="el-icon-search"
                                class="ele-btn-icon">查询
                            </el-button>
                            <el-button @click="(table.where={})&&$refs.table.reload()">重置</el-button>
                            <el-button type="success" @click="exportExcel();" icon="el-icon-download"
                                class="ele-btn-icon"
                                v-if="permission.includes('sys:activityturntableprize:export')">导出数据
                            </el-button>
                        </el-form-item>
                    </el-row>
                </el-form>
                <!-- 操作按钮 -->

                <div class="ele-table-tool ele-table-tool-default">
                    <el-button @click="(table.where={})&&$refs.table.reload()" type="info" icon="el-icon-refresh"
                        class="ele-btn-icon" size="small">刷新
                    </el-button>
                    <el-button @click="showEdit=true" type="primary" icon="el-icon-plus" class="ele-btn-icon"
                        size="small" v-if="permission.includes('sys:activityturntableprize:add')">添加
                    </el-button>
                    <el-button @click="remove()" type="danger" icon="el-icon-delete" class="ele-btn-icon" size="small"
                        v-if="permission.includes('sys:activityturntableprize:dall')">批量删除
                    </el-button>
                    <el-button :type="search_show?'warning':'info'" size="small" icon="el-icon-search"
                        @click="search_show=!search_show">搜索</el-button>
                </div>

                <!-- 数据表格 -->
                <ele-data-table ref="table" :config="table" :choose.sync="choose" height="calc(100vh - 315px)"
                    highlight-current-row>
                    <template slot-scope="{index}">
                        <el-table-column type="selection" width="45" align="center" fixed="left" />
                        <el-table-column type="index" :index="index" label="编号" width="60" align="center" fixed="left"
                            show-overflow-tooltip />
                        <el-table-column prop="cate_id" label="分类名称" show-overflow-tooltip min-width="250">
                            <template slot-scope="{row}">
                                <el-tag v-for="(item,index) in row.cate_id_info" :key="index">{{item.title}}</el-tag>
                            </template>
                        </el-table-column>


                        <el-table-column prop="prize_name" label="奖项名称" sortable="custom" show-overflow-tooltip
                            min-width="120" />
                        <el-table-column prop="prize_img" label="奖项图片" show-overflow-tooltip min-width="250">
                            <template slot-scope="{row}">
                                <el-image style="width: 50px; height: 50px" :src="row.prize_img"
                                    :preview-src-list="[row.prize_img]">
                                </el-image>
                            </template>
                        </el-table-column>

                        <el-table-column prop="prize_grade" label="奖项等级（一等奖）" sortable="custom" show-overflow-tooltip
                            min-width="120" />

                        <el-table-column prop="prize_num" label="奖项数量" sortable="custom" show-overflow-tooltip
                            min-width="120" />
                            <el-table-column prop="price" label="价格" sortable="custom" show-overflow-tooltip
                                min-width="120" />
                        <el-table-column prop="prize_chance" label="中奖概率(‰)" sortable="custom" show-overflow-tooltip
                            min-width="120" />

                        <el-table-column prop="sort" label="奖品排序" sortable="custom" show-overflow-tooltip
                            min-width="120" />

                        <el-table-column label="创建时间" sortable="custom" show-overflow-tooltip min-width="160">
                            <template slot-scope="{row}">{{ row.create_time*1000 | toDateString }}</template>
                        </el-table-column>
                        <el-table-column label="更新时间" sortable="custom" show-overflow-tooltip min-width="160">
                            <template slot-scope="{row}">{{ row.update_time*1000 | toDateString }}</template>
                        </el-table-column>
                        <el-table-column label="操作" width="130px" align="center" :resizable="false" fixed="right">
                            <template slot-scope="{row}">
                                <el-link @click="edit(row)" icon="el-icon-edit" type="primary" :underline="false"
                                    v-if="permission.includes('sys:activityturntableprize:edit')">修改</el-link>
                                <el-popconfirm title="确定要删除此活动奖品吗？" @confirm="remove(row)" class="ele-action">
                                    <el-link slot="reference" icon="el-icon-delete" type="danger" :underline="false"
                                        v-if="permission.includes('sys:activityturntableprize:delete')">删除</el-link>
                                </el-popconfirm>
                            </template>
                        </el-table-column>
                    </template>
                </ele-data-table>
            </el-card>
            <!-- 编辑弹窗 -->
            <el-dialog :title="editForm.id?'修改活动奖品':'添加活动奖品'" :visible.sync="showEdit" width="800px"
                :destroy-on-close="true" :lock-scroll="false" @close="closeDialog" :close-on-click-modal="false">
                <el-form :model="editForm" ref="editForm" :rules="editRules" label-width="auto" class="demo-ruleForm">
                    <el-form-item label="分类名称:" prop="cate_id">
                        <el-select v-model="editForm.cate_id" filterable placeholder="请选择">
                            <el-option v-for="item in activity_turntable_prize_cate_list" :key="item.id"
                                :label="item.title" :value="item.id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item label="奖项类型:" prop="mode">
                        <el-radio-group v-model="editForm.mode">
                            <el-radio label="1">实物</el-radio>
                            <el-radio label="2">优惠券</el-radio>
                            <el-radio label="3">积分</el-radio>
                          </el-radio-group>
                    </el-form-item>
                    <el-form-item label="奖项名称:" prop="prize_name">
                        <el-input v-model="editForm.prize_name" placeholder="请输入奖项名称" clearable />
                    </el-form-item>
                    <el-form-item label="奖项图片:" prop="prize_img">
                        <ele-uploadimage :limit="1" v-model="editForm.prize_img"></ele-uploadimage>
                    </el-form-item>
                    <el-form-item label="奖项详情:" prop="prize_content">
                        <tinymce-editor v-model="editForm.prize_content" :init="initEditor" />
                    </el-form-item>
                    <el-form-item label="奖项等级（一等奖）:" prop="prize_grade">
                        <el-input v-model="editForm.prize_grade" placeholder="请输入奖项等级（一等奖）" clearable />
                    </el-form-item>
                    <el-form-item label="价格:" prop="price" v-if="editForm.mode == 1">
                        <el-input-number v-model="editForm.price" controls-position="right" :min="0" :controls="false"
                            :precision="2" class="ele-fluid ele-text-left" placeholder="请输入价格" clearable />
                    </el-form-item> 
                    <el-form-item label="优惠券:" prop="coupon_id" v-if="editForm.mode == 2">
                        <el-select v-model="editForm.coupon_id" filterable multiple placeholder="请选择">
                         <el-option
                              v-for="item in store_coupon_list"
                              :key="item.id"
                              :label="item.title"
                              :value="item.id"
                              >
                            </el-option>
                            </el-select>
                    </el-form-item> 
                    <div  v-if="editForm.mode == 3"  style="margin-bottom: 10px;">
                        <el-form-item label="积分数量" prop="value">
                            <el-input placeholder="请输入积分数量" v-model="title" style="width: 85%;"></el-input><el-button @click.prevent="integralTitleAdd()">添加</el-button>
                            <el-tag
                            v-for="(item,index) in editForm.integral_num " :key="index"
                              closable
                               @close="deleteTips(index)">
                              {{item}}
                            </el-tag>
                        </el-form-item>
                    </div>
                    <el-form-item label="奖项数量:" prop="prize_num">
                        <el-input-number v-model="editForm.prize_num" controls-position="right" :controls="false"
                            :precision="0" class="ele-fluid ele-text-left" placeholder="请输入奖项数量" clearable />
                    </el-form-item>
                    <el-form-item label="中奖概率(‰):" prop="prize_chance">
                        <el-input v-model="editForm.prize_chance" placeholder="请输入中奖概率(‰)" clearable />
                    </el-form-item>

                    <el-form-item label="奖品排序:" prop="sort">
                        <el-input-number v-model="editForm.sort" controls-position="right" :controls="false"
                            :precision="0" class="ele-fluid ele-text-left" placeholder="请输入奖品排序" clearable />
                    </el-form-item>
                    <el-form-item label="物流模板:" prop="fare_id">
                        <el-select v-model="editForm.fare_id" filterable placeholder="请选择" @change="selectGoodsCatId">
                            <el-option v-for="item in logistics_fare_list" :key="item.id" :label="item.title"
                                :value="item.id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-form>
                <div slot="footer">
                    <el-button @click="closeDialog">取消</el-button>
                    <el-button type="primary" @click="save">保存</el-button>
                </div>
            </el-dialog>
        </div>
    </template>

    <script>
        import {
            mapGetters
        } from "vuex";

        import EleUploadimage from '@/components/EleUploadimage'
    import TinymceEditor from '@/components/TinymceEditor'
        export default {
            name: "SysActivityTurntablePrize",
            components: {
                EleUploadimage,
                TinymceEditor
            },
            data() {
                return {
                    title:'',
                    table: {
                        url: '/activity/ActivityTurntablePrize/index',
                        where: {
                            "prize_img": []
                        }
                    }, // 表格配置
                    choose: [], // 表格选中数据
                    showEdit: false, // 是否显示表单弹窗
                    editForm: {
                        "prize_img": [],
                        integral_num:[],
                        mode:'1',
                        coupon_id:[]
                    }, // 表单数据
                    editFormTemp: {
                        "prize_img": []
                    },
                    admin_list: [],
                    user_list: [],
                    temp_coupon_id:[],
                    search_show: false,
                    activity_turntable_prize_cate_list: [],
                    store_coupon_list:[],
                    logistics_fare_list:[],
                    editRules: { // 表单验证规则

                        cate_id: [{
                            required: true,
                            message: '请选择分类名称',
                            trigger: 'blur'
                        }],

                        prize_content:[{
                            required: true,
                            message: '请输入奖项详情',
                            trigger: 'blur'
                        }],
                        prize_name: [{
                            required: true,
                            message: '请输入奖项名称',
                            trigger: 'blur'
                        }],


                        prize_img: [{
                            required: true,
                            message: '请上传奖项图片',
                            trigger: 'blur'
                        }],


                        prize_grade: [{
                            required: true,
                            message: '请输入奖项等级（一等奖）',
                            trigger: 'blur'
                        }],


                        prize_num: [{
                            required: true,
                            message: '请输入奖项数量',
                            trigger: 'blur'
                        }],
                        prize_chance: [{
                            required: true,
                            message: '请输入中奖概率',
                            trigger: 'blur'
                        }],
                        prize_time: [{
                            required: true,
                            message: '请选择时间',
                            trigger: 'blur'
                        }],
                        create_time: [{
                            required: true,
                            message: '请选择创建时间',
                            trigger: 'blur'
                        }],
                        price:[{
                            required: true,
                            message: '请输入价格',
                            trigger: 'blur'
                        }],
                        title: [{
                            required: true,
                            message: '请输入标题',
                            trigger: 'blur'
                        }],
                        coupon_id:[{
                            required: true,
                            message: '请选择优惠券',
                            trigger: 'blur'
                        }],
                        integral_num:[{
                            required: true,
                            message: '请添加积分',
                            trigger: 'blur'
                        }],
                        fare_id:[{
                            required: true,
                            message: '请选择运费模板',
                            trigger: 'blur'
                        }],

                    },
                }
            },
            computed: {
                ...mapGetters(["permission"]),
            },
            mounted() {

                this.ActivityTurntablePrizeCateAllList();
                this.StoreCouponList();
                this.logisticsFareAllList();
            },
            methods: {
                //获取物流信息
                logisticsFareAllList(){
                    this.$http.post('/logistics/logisticsFare/allList').then(res => {
                        if (res.data.code === 0) {
                            this.logistics_fare_list = res.data.data;
                        } else {
                            this.$message.error(res.data.msg);
                        }
                    }).catch(e => {
                        this.$message.error(e.message);
                    });
                },
                /* 删除积分*/
                deleteTips(index){
                    this.editForm.integral_num.splice(index,1);
                },
                /* 添加积分*/
                integralTitleAdd(){
                    if(this.title !== ''&& this.title>0){
                        this.editForm.integral_num.push(this.title);
                        this.title = '';
                    }
                },
                /**
                 * 关闭
                 */
                closeDialog() {
                    this.showEdit = false;
                    this.editForm = JSON.parse(JSON.stringify(this.editFormTemp));
                },
                /**
                 * 显示编辑
                 */
                edit(row) {
                    this.$http.get('/activity/ActivityTurntablePrize/info?id=' + row.id).then(res => {
                        if (res.data.code === 0) {
                            this.showEdit = true;
                            setTimeout(() => {
                                res.data.data.integral_num = res.data.data.integral_num?(res.data.data.integral_num.split(",")):[];
                                res.data.data.coupon_id = res.data.data.coupon_id?(res.data.data.coupon_id.split(",")):[];
                                for(var i = 0;i<res.data.data.coupon_id.length;i++){
                                    res.data.data.coupon_id[i] = parseInt(res.data.data.coupon_id[i])
                                }
                                this.editForm = res.data.data;
                            }, 100);
                        } else {
                            this.$message.error(res.data.msg);
                        }
                    }).catch(e => {
                        this.$message.error(e.message);
                    });
                },
                /**
                 * 保存编辑
                 */
                save() {
                    this.$refs['editForm'].validate((valid) => {
                        if (valid) {
                            const loading = this.$loading({
                                lock: true
                            });
                            this.$http.post('/activity/ActivityTurntablePrize/edit', this.editForm).then(
                            res => {
                                loading.close();
                                if (res.data.code === 0) {
                                    this.showEdit = false;
                                    this.$message({
                                        type: 'success',
                                        message: res.data.msg
                                    });
                                    this.$refs.table.reload();
                                } else {
                                    this.$message.error(res.data.msg);
                                }
                            }).catch(e => {
                                loading.close();
                                this.$message.error(e.message);
                            });
                        } else {
                            return false;
                        }
                    });
                },
                /**
                 * 刪除(批量刪除)
                 */
                remove(row) {
                    console.log(row)
                    if (!row) { // 批量删除
                        if (this.choose.length === 0) return this.$message.error('请至少选择一条数据');
                        let ids = this.choose.map(d => d.id);
                        this.$confirm('确定要删除选中的活动奖品吗?', '提示', {
                            type: 'warning'
                        }).then(() => {
                            const loading = this.$loading({
                                lock: true
                            });
                            this.$http.post('/activity/ActivityTurntablePrize/delete', {
                                id: ids
                            }).then(res => {
                                loading.close();
                                if (res.data.code === 0) {
                                    this.$message({
                                        type: 'success',
                                        message: res.data.msg
                                    });
                                    this.$refs.table.reload();
                                } else {
                                    this.$message.error(res.data.msg);
                                }
                            }).catch(e => {
                                loading.close();
                                this.$message.error(e.message);
                            });
                        }).catch(() => 0);
                    } else { // 单个删除
                        const loading = this.$loading({
                            lock: true
                        });
                        this.$http.post('/activity/ActivityTurntablePrize/delete', {
                            id: row.id
                        }).then(res => {
                            loading.close();
                            if (res.data.code === 0) {
                                this.$message({
                                    type: 'success',
                                    message: res.data.msg
                                });
                                this.$refs.table.reload();
                            } else {
                                this.$message.error(res.data.msg);
                            }
                        }).catch(e => {
                            loading.close();
                            this.$message.error(e.message);
                        });
                    }
                },

                /* 导出数据Excel */
                exportExcel() {
                    let ids = this.choose.map(d => d.id)
                    if (ids.length == 0) {
                        this.$message.error('请选择要导出的数据');
                        return false;
                    }
                    this.$http
                        .post("/activity/ActivityTurntablePrize/exportExcel", {
                            id: ids
                        })
                        .then((res) => {
                            let data = res.data;
                            if (data.code == 0) {
                                // 下载文件
                                window.location.href = data.data;
                                this.$message({
                                    type: "success",
                                    message: "导出成功",
                                });
                            } else {
                                this.$message.error("导出失败");
                            }
                        })
                },

                //查询其他信息
                ActivityTurntablePrizeCateAllList() {
                    this.$http.post('/activity/ActivityTurntablePrizeCate/allList', {}).then(res => {
                        if (res.data.code === 0) {
                            this.activity_turntable_prize_cate_list = res.data.data;
                        } else {
                            this.$message.error(res.data.msg);
                        }
                    }).catch(e => {
                        this.$message.error(e.message);
                    });
                },
                StoreCouponList(){
                    this.$http.post('/store/StoreCoupon/allList', {}).then(res => {
                        if (res.data.code === 0) {
                            this.store_coupon_list = res.data.data;
                        } else {
                            this.$message.error(res.data.msg);
                        }
                    }).catch(e => {
                        this.$message.error(e.message);
                    });
                }

            }
        }
    </script>

    <style scoped>
        .ele-block>>>.el-upload,
        .ele-block>>>.el-upload-dragger {
            width: 100%;
        }
    </style>